<template>
  <v-container>
    <v-layout class="py-1" row wrap v-for="[key, value] of Object.entries(configuration)" :key="key">
      <v-flex md4 sm12>
        <b>{{ capitalize(spaceBeforeCapital(key)) }}</b>:
      </v-flex>
      <v-flex md8 sm12 style="max-height: 200px; overflow: auto;">
        <template v-if="key != 'password'">{{value}}</template>
        <template v-else>*****</template>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    props: {
      configuration: Object,
    },
    methods: {
      spaceBeforeCapital(val) {
        return val.replace(/([A-Z])/g, ' $1').trim()
      },
      capitalize(val) {
        return val.charAt(0).toUpperCase() + val.slice(1)
      },
    },
  }
</script>